<template>
  <v-card height="130px" v-bind="$attrs" v-on="$listeners" style="flex: 1 1; min-width: 142px; max-width: 50%">
    <v-img height="130px" :src="item.image ? `${$store.getters.url}/media/image/${item.image}` : ''">
      <div class="pa-1" style="backdrop-filter: blur(1px); background: #31313188; color: white; border-radius: .3em; height: 100%; width: 100%">
        <slot name="default">
          {{item.alt_name || item.name}}
        </slot>
      </div>
    </v-img>
  </v-card>
</template>

<script>
export default {
  props: {
    item: Object
  }
}
</script>